import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Page404 = () => {
  return (
    <Container>
      <Content>
        <h1>404</h1>
        <h2>Oops! Page not found.</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <StyledLink to="/">Go back home</StyledLink>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100%;
  background: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2em;
`;

const Content = styled.div`
  text-align: center;
  h1 {
    font-size: 10rem;
    font-weight: 900;
  }
  h2 {
    font-size: 2rem;
    margin: 1rem 0;
  }
  p {
    color: #aaa;
    margin-bottom: 2rem;
  }
`;

const StyledLink = styled(Link)`
  padding: 0.8rem 2rem;
  background: #ffffff11;
  backdrop-filter: blur(10px);
  color: white;
  border-radius: 30px;
  font-size: 1rem;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #ffffff33;
  }
`;

export default Page404;
